// convertkitAPI.js
// convertkitAPI.js

// https://developers.kit.com/v4.html?javascript#introduction
//https://help.kit.com/en/articles/9427725-configuring-api-access


const ACCESS_TOKEN = 'kit_9c5059f6ac4dd1413409c030aaeb75c2'; // your real V4 key here
const BASE_URL = 'https://api.kit.com/v4';

async function fetchFromKit(endpoint) {
  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${ACCESS_TOKEN}`,
      'Content-Type': 'application/json'
    }
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(`Kit API Error: ${res.status} - ${JSON.stringify(errorData)}`);
  }

  return res.json();
}

export async function fetchSubscribers() {
  const data = await fetchFromKit('/subscribers');
  return data.total_count ?? 0;
}

export async function fetchBroadcasts() {
  const data = await fetchFromKit('/broadcasts');
  return data.broadcasts ?? [];
}

export async function fetchForms() {
  const data = await fetchFromKit('/forms');
  return data.forms ?? [];
}




// // ConvertKitAPI.js   - v4

// const API_KEY = 'e-IMK1y5--B5pVKKX2_5HQ';
// const BASE_URL = 'https://api.kit.com/v4';

// // ✅ Add common fetch with headers
// const fetchFromKit = async (endpoint) => {
//   const res = await fetch(`${BASE_URL}${endpoint}`, {
//     headers: {
//       Authorization: `Bearer ${API_KEY}`,
//       'Content-Type': 'application/json',
//     },
//   });

//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Kit API Error: ${res.status} - ${errorText}`);
//   }

//   return res.json();
// };

// // ✅ Get total subscribers (paginated list)
// export async function fetchSubscribers() {
//   const data = await fetchFromKit('/subscribers');
//   return data.total || data.subscribers?.length || 0;
// }

// // ✅ Get recent broadcasts (newsletters)
// export async function fetchBroadcasts() {
//   const data = await fetchFromKit('/broadcasts');
//   return data.broadcasts || [];
// }

// // ✅ Fetch forms (optional)
// export async function fetchForms() {
//   const data = await fetchFromKit('/forms');
//   return data.forms || [];
// }

